module.exports = __webpack_public_path__ + "static/loader-trancition-1cc123f7f15e87e42e76b349da09257c.gif";